<app-page-layout>
  <app-page-content [narrow]="true">

    <app-test-execution *ngIf="urlCode"
                        [urlCode]="urlCode"></app-test-execution>

  </app-page-content>
</app-page-layout>
